import { BaseService } from "./BaseService";
import {
  CheckoutFeedback,
  CheckoutFeedbackFilter,
  CommunicationFeedback,
  CommunicationFeedbackFilter,
  FeedbacksFindAllResponse,
  IFeedbackService,
  RequestFeedback,
  RequestFeedbackFilter,
} from "./interfaces/IFeedbackService";

class FeedbacksService extends BaseService implements IFeedbackService {
  constructor() {
    super();
  }

  getAllRequestFeedbacks(
    filters: RequestFeedbackFilter,
  ): Promise<FeedbacksFindAllResponse<RequestFeedback>> {
    return this.get<FeedbacksFindAllResponse<RequestFeedback>>(
      "/requests-feedbacks",
      filters,
    );
  }
  getAllCommunicationFeedbacks(
    filters: CommunicationFeedbackFilter,
  ): Promise<FeedbacksFindAllResponse<CommunicationFeedback>> {
    return this.get<FeedbacksFindAllResponse<CommunicationFeedback>>(
      "/communications-feedbacks",
      filters,
    );
  }

  getAllCheckoutFeedbacks(
    filters: CheckoutFeedbackFilter,
  ): Promise<FeedbacksFindAllResponse<CheckoutFeedback>> {
    return this.get<FeedbacksFindAllResponse<CheckoutFeedback>>(
      "/checkout-feedbacks",
      filters,
    );
  }
}

export const feedbacksService = new FeedbacksService();
